"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOsDetails = exports.getBrowserDetails = void 0;
var getBrowserDetails = function () {
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = "" + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset;
    var verOffset;
    var ix;
    // In Opera, the true version is after "Opera" or after "Version"
    if (nAgt.indexOf('Opera') !== -1) {
        verOffset = nAgt.indexOf('Opera');
        browserName = 'Opera';
        fullVersion = nAgt.substring(verOffset + 6);
        if (nAgt.indexOf('Version') !== -1) {
            verOffset = nAgt.indexOf('Version');
            fullVersion = nAgt.substring(verOffset + 8);
        }
    }
    else if (nAgt.indexOf('MSIE') !== -1) {
        // In MSIE, the true version is after "MSIE" in userAgent
        verOffset = nAgt.indexOf('MSIE');
        browserName = 'Microsoft Internet Explorer';
        fullVersion = nAgt.substring(verOffset + 5);
    }
    else if (nAgt.indexOf('Chrome') !== -1) {
        // In Chrome, the true version is after "Chrome"
        verOffset = nAgt.indexOf('Chrome');
        browserName = 'Chrome';
        fullVersion = nAgt.substring(verOffset + 7);
    }
    else if (nAgt.indexOf('Safari') !== -1) {
        // In Safari, the true version is after "Safari" or after "Version"
        verOffset = nAgt.indexOf('Safari');
        browserName = 'Safari';
        fullVersion = nAgt.substring(verOffset + 7);
        if (nAgt.indexOf('Version') !== -1) {
            verOffset = nAgt.indexOf('Version');
            fullVersion = nAgt.substring(verOffset + 8);
        }
    }
    else if (nAgt.indexOf('Firefox') !== -1) {
        // In Firefox, the true version is after "Firefox"
        verOffset = nAgt.indexOf('Firefox');
        browserName = 'Firefox';
        fullVersion = nAgt.substring(verOffset + 8);
    }
    else if ((nAgt.lastIndexOf(' ') + 1) < nAgt.lastIndexOf('/')) {
        // In most other browsers, "name/version" is at the end of userAgent
        nameOffset = nAgt.lastIndexOf(' ') + 1;
        verOffset = nAgt.lastIndexOf('/');
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if (fullVersion.indexOf(';') !== -1) {
        ix = fullVersion.indexOf(';');
        fullVersion = fullVersion.substring(0, ix);
    }
    if (fullVersion.indexOf(' ') !== -1) {
        ix = fullVersion.indexOf(' ');
        fullVersion = fullVersion.substring(0, ix);
    }
    majorVersion = parseInt("" + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }
    return {
        browserName: browserName,
        fullVersion: fullVersion,
        majorVersion: majorVersion,
    };
};
exports.getBrowserDetails = getBrowserDetails;
var getOsDetails = function () {
    var detectedOS = 'Unknown OS';
    if (navigator.appVersion.indexOf('Mac') !== -1) {
        detectedOS = 'MacOS';
    }
    if (navigator.appVersion.indexOf('Win') !== -1) {
        detectedOS = 'Windows';
    }
    if (navigator.appVersion.indexOf('Linux') !== -1) {
        detectedOS = 'Linux';
    }
    return detectedOS;
};
exports.getOsDetails = getOsDetails;
